import {
  TerminalGetTypesRequest,
  type GetTerminalRequest,
  type SearchTerminalsRequest,
} from '@trukt/tms-api';
import { createKey } from '../createKey';
import { TerminalContactServiceKeys } from './serviceKeys';

const keyHandler = createKey('terminal');

export const TerminalServiceKeys = {
  key: keyHandler.key,
  getById: keyHandler.createMethod<GetTerminalRequest>(),
  search: keyHandler.createMethod<SearchTerminalsRequest>(),
  contact: TerminalContactServiceKeys,
  getTypes: keyHandler.createMethod<TerminalGetTypesRequest>(),
};
